import InvestmentProductSelect from "./InvestmentProductSelect";

export default InvestmentProductSelect;